import { render, staticRenderFns } from "./NewBike.vue?vue&type=template&id=2674d5b2"
import script from "./NewBike.vue?vue&type=script&lang=js"
export * from "./NewBike.vue?vue&type=script&lang=js"
import style0 from "./NewBike.vue?vue&type=style&index=0&id=2674d5b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports